import { Insurer, RiskVariant, Selection } from 'BrokerTsLib/src/enums';
import * as yup from 'yup';
import { PropertyAddressValidationRuleObject, PropertyHouseholdValidationSchema, PropertyRealtyValidationSchema, customNullable, isInsurersAvailable } from "..";

export const PropertyDataValidationRuleObject = (realtyType: any, insurers: any) => {
    return {
        address: yup.object({ ...PropertyAddressValidationRuleObject }),

        hasNonresidentialPremises: yup
            .boolean()
            .nullable()
            .when("realtyTypeId", {
                is: (type?: string) => type == Selection.Byt.toString(),
                then: () => yup
                    .boolean()
                    .nullable()
                    .required("Zvolte jestli byt má nebytové prostory"),
                otherwise: undefined,
            }),

        hasBasement: yup
            .boolean()
            .nullable()
            .when("realtyTypeId", {
                is: (type?: string) => type != Selection.Byt.toString(),
                then: () => yup
                    .boolean()
                    .nullable()
                    .required("Zvolte jestli je dům podsklepený"),
                otherwise: undefined,
            }),

        hasGarageOnDifferentLocation: yup
            .boolean()
            .nullable()
            .when([], () => {
                return isInsurersAvailable(insurers, [Insurer.CPP, Insurer.Direct])
                    ? yup.boolean().nullable().required("Vyberte jestli je garáž na jiné adrese")
                    : yup.boolean().nullable().notRequired()
            }),

        garageAtOtherLocationAmount:
            customNullable(yup.number())
                .when("hasGarageOnDifferentLocation", {
                    is: (diffLoc?: boolean) => diffLoc == true,
                    then: () =>
                        customNullable(yup.number())
                            .required("Zadejte pojistnou částku budovy garáže"),
                    otherwise: undefined,
                }),

        garageAddress: yup
            .object()
            .nullable()
            .when("hasGarageOnDifferentLocation", {
                is: (diffLoc?: boolean) => diffLoc == true,
                then: () => yup.object({ ...PropertyAddressValidationRuleObject }),
                otherwise: undefined,
            }),

        realty: yup
            .object()
            .nullable()
            .when(["realtyTypeId", "hasBasement"], ([realtyTypeId, hasBasement], schema) => {
                if (realtyType == RiskVariant.Household)
                    return yup.object().nullable().notRequired();
                return PropertyRealtyValidationSchema(realtyTypeId, hasBasement, insurers);
            }),

        household: yup
            .object()
            .nullable()
            .when(["realtyTypeId"], ([realtyTypeId], schema) => {
                if (realtyType == RiskVariant.Realty)
                    return yup.object().nullable().notRequired();
                return PropertyHouseholdValidationSchema(realtyTypeId, realtyType != RiskVariant.Household, insurers);
            }),

        realtyTypeId: yup
            .string()
            .nullable()
            .required("Vyberte typ nemovitosti"),

        secondaryRealties: yup
            .array()
            .nullable()
            .transform((value, originalValue) => (originalValue === '' || originalValue === null ? [] : value))
            .when(["realty"], ([realty]) => {
                return realty?.secondaryRealty == true
                    ? yup
                        .array()
                        .nullable()
                        .of(
                            yup.object().shape({
                                secondaryRealtyAmount:
                                    customNullable(yup.number())
                                        .required("Zadejte hodnotu stavby")
                                        .min(1000, "Hodnota vedlejší stavby musí být minimálně 1 000 Kč"),
                            })
                        )
                    : yup.array().nullable().notRequired()
            })
            .default([])
    }
}

export const PropertyDataValidationSchema = (realtyType: any, insurers: any) => yup.object().shape(PropertyDataValidationRuleObject(realtyType, insurers))